import gql from 'graphql-tag'

export default gql`
  query getProductsInCategory($urlKey: String!) {
    getProductsInCategory(urlKey: $urlKey) {
      category_name
      all_a_z {
        id
        img_url
        name
        url_key
        categories
        keywords
        description
      }
    }
  }
`
